import { enumFolderType } from "../constants";
import { IsTrashFolder } from "../utils/IsTrashFolder";
import { QFile } from "./QFile";
import { IsHiddenFolder } from "../utils/IsHiddenFolder";

export class QFolder {
  constructor() {
    this.fFolderName = null;
    this.fDisplayName = null;
    this.fLocked = false;
    this.fFileList = null;
    this.fReady = false;
    this.fFileMgr = null;
    this.fCached = false;
  }

  InitFolder(folderName, locked, fileMgr, displayName) {
    this.fFileMgr = fileMgr;
    this.fFolderName = folderName;
    if (displayName != null) this.fDisplayName = displayName;
    this.fLocked = locked;
    this.fFileList = null;
  }

  GetFolderDisplayName() {
    if (this.fDisplayName == null) return this.fFolderName;
    else return this.fDisplayName;
  }

  IsLocked() {
    return this.fLocked;
  }

  IsCached() {
    return this.fCached;
  }

  SetCacheState(state) {
    this.fCached = state;
  }

  AddFile(fullFileName) {
    var aFile = new QFile();
    aFile.InitFile(fullFileName, this, this.fFileMgr);
    this.fFileList.push(aFile);
    return aFile;
  }

  SetReady() {
    this.fReady = true;
  }

  IsReady() {
    return this.fReady;
  }

  ClearFolder() {
    var done = false;
    while (!done) {
      var aFile = this.fFileList.pop();
      if (aFile == null) done = true;
    }
  }

  ClearCache() {
    this.fFileList = null;
  }

  GetFolderName() {
    return this.fFolderName;
  }

  SetFolderName(folderName) {
    this.fFolderName = folderName;
  }

  GetNumFiles() {
    if (this.fFileList != null) return this.fFileList.length;
  }

  GetIndexFile(index) {
    return this.fFileList[index];
  }

  GetFullNameIndex(fullName) {
    var n = this.GetNumFiles();

    for (var i = 0; i < n; i++) {
      var aFile = this.GetIndexFile(i);
      if (aFile.GetFileName(true).toLowerCase() == fullName.toLowerCase()) return i;
    }

    return -1;
  }

  ExcludeFolders(reader) {
    var exclude = false;
    var folderName = this.GetFolderName();

    exclude = IsHiddenFolder(folderName);
    if (!exclude && reader) exclude = IsTrashFolder(folderName);

    /*
    switch (folderName)
    {
      case 'System':
      case 'Temp':
        exclude = true;
        break;
    }

    if (reader && !exclude)
    {
      switch (folderName)
      {
      //	case "Tutorials":
      //	case 'Samples':
        case 'Trash':
      //	case 'Public':
          exclude = true;
          break;
      }
    }
    */

    return exclude;
  }

  GetFolderType() {
    var folderName = this.GetFolderName();
    var folderType; // = enumFolderType.std;
    switch (folderName) {
      //case "Tutorials":
      //	folderType = enumFolderType.tutorials;
      //	break;
      case "Public":
        folderType = enumFolderType.publicf;
        break;
      case "Samples":
        folderType = enumFolderType.sample;
        break;
      case "Trash":
        folderType = enumFolderType.trash;
        break;
      default:
        folderType = enumFolderType.std;
        if (this.IsLocked()) folderType = enumFolderType.stdlock;
        break;
    }

    return folderType;
  }
}
